import { RootState } from '../store';

export const selectEmployees = (state: RootState) => state.employees.employeesData;
export const selectEmployeeLoaded = (state: RootState) => state.employees.loaded;
export const selectEmployeeError = (state: RootState) => state.employees.error;
